import { Inject, Injectable } from '@angular/core';

@Injectable()
export class SuccessToaster {
  constructor(@Inject('$mdToast') private $mdToast, @Inject('Rollbar') private Rollbar) {}

  private _actionToast(data) {
    return this.$mdToast.build({
      template: require('./action-toast.html'),
      position: 'top right',
      toastClass: 'toasted',
      hideDelay: 0,
      controller($rootScope) {
        let self = this;

        self.refresh = function() {
          /**
           * A success SSV update would emit this event and student updates, which would be picked up the sdcGridCtrl.
           * There is a listener on sdcGridCtrl that will then call a method on api to REFETCH the student(s)
           */
          $rootScope.$emit('refetchRequest', data);
          this.$mdToast.hide('refetched');
        };

        self.dismiss = function() {
          this.$mdToast.cancel('cancelled');
        };
      },
      controllerAs: 'toastCtrl',
    });
  }

  private _notificationToast(data) {
    return this.$mdToast.build({
      template: require('./notification-toast.html'),
      position: 'top right',
      toastClass: 'toasted',
      controller() {
        let self = this;
        self.num = data.config.data._ids.length;
      },
      controllerAs: 'toastCtrl',
    });
  }

  public actionToast(data) {
    this.$mdToast.show(this._actionToast(data)).catch(err => {
      if (err) this.Rollbar.warning(err);
      this.Rollbar.warning('Failed to show toast');
    });
  }

  public notificationToast(data) {
    this.$mdToast.show(this._notificationToast(data)).catch(err => {
      if (err) this.Rollbar.warning(err);
      this.Rollbar.warning('Failed to show toast');
    });
  }
}
